// extracted by mini-css-extract-plugin
module.exports = {"root":"GoToCommentLink-root-49c2b4c6c8af346ce7814325e2fc938f"};